/** Shared by the app, which draws canvas nodes, and the agent, which places them. */

/** Chakra size 72. Content scales down to fill it, and a stand-in keeps it so its preview draws as on the node. */
export const CANVAS_NODE_WIDTH = 288;
/** The space between neighboring nodes in one group. */
export const CANVAS_NODE_GAP = 48;
/** A document node's height over its width. */
export const CANVAS_DOC_ASPECT_RATIO = 1.4167;
/** In email px: the height an email node draws before it has measured the email, and the most it grows. */
export const CANVAS_EMAIL_FALLBACK_HEIGHT = 800;
export const CANVAS_EMAIL_MAX_HEIGHT = 2400;

/** The name row and the gap under it, above a node's content. */
export const CANVAS_NODE_HEADER_HEIGHT = 30;
/** Most emails are 600px wide. */
const EMAIL_WIDTH = 600;
/** The subject and preheader above an email. */
const EMAIL_ENVELOPE_HEIGHT = 68;
/** An email node's content at its tallest, so a long one clears what sits below it. */
export const CANVAS_EMAIL_CONTENT_HEIGHT =
  EMAIL_ENVELOPE_HEIGHT +
  Math.round((CANVAS_EMAIL_MAX_HEIGHT * CANVAS_NODE_WIDTH) / EMAIL_WIDTH);
/** A web page node's content for a long landing page; the app draws the whole page. */
export const CANVAS_WEB_PAGE_CONTENT_HEIGHT = 1400;
